import styled from "styled-components";

import { DEFAULT_MARGIN_XL } from "@src/common/styles/const";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${DEFAULT_MARGIN_XL}px;
`;
